/* eslint-disable */
import React, {
 memo,
 useCallback,
 useEffect,
 useMemo,
 useRef,
 useState,
} from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import {
 FirstDataRenderedEvent,
 GridOptions,
 RowClassRules,
 RowHeightParams,
} from 'ag-grid-community';
import agGridLocale from '../translation/agGridLocale';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import cloneDeep from 'lodash/cloneDeep';
import srv from '../../../services';
import { contractDetailData } from '../../../store/reducers/contractDetailDataSlice';
import { StapletIcon } from '../../_assests';
import { DownloadButton } from '../../_common';

const useStyles = makeStyles({
 agHeader: {
  justifyContent: 'center',
  marginBottom: '20px !important',
  '& .ag-root-wrapper': {
   borderRadius: '5px',
  },

  '& .ag-header': {
   backgroundColor: '#FFB614',
   color: 'black',
  },

  '& .ag-full-width-row': {
   height: '500px !important',
  },

  '& .ag-cell': {
   fontSize: '12px',
  },

  '& .ag-header-cell-label': {
   justifyContent: 'center !important',
   color: 'black',
   fontWeight: 400,
   fontSize: '12px',
  },

  '& .ag-text-field-input': {
   backgroundColor: 'white !important',
  },

  '& .ag-header-icon': {
   color: 'white !important',
  },

  '& .ag-cell:focus': {
   border: 'none !important',
   outline: 'none',
  },

  '& .ag-row-selected': {
   backgroundColor: '#8180c3',
   color: 'white',
  },
  '& .ag-theme-alpine .ag-row-selected .ag-row-hover': {
   backgroundColor: 'red !important',
  },
  '& .MuiSvgIcon-root': {
   color: '#663d00',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-row-selected': {
   backgroundColor: '#4abbff',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-ltr .ag-cell-focus': {
   color: '#663d00',
  },
  '& .ag-root-wrapper.ag-layout-normal': {
   height: '100% !important',
  },
 },

 agHeaderShort: {
  justifyContent: 'center !important',
  '& .ag-root-wrapper': {
   borderRadius: '5px',
  },

  '& .ag-header': {
   backgroundColor: '#FFB614',
   color: 'white',
  },

  '& .ag-cell': {
   fontSize: '12px',
  },

  '& .ag-header-cell-label': {
   justifyContent: 'center !important',
   color: 'white',
   fontWeight: 400,
   fontSize: '12px',
  },

  '& .ag-text-field-input': {
   backgroundColor: 'white !important',
  },

  '& .ag-header-icon': {
   color: 'white !important',
  },

  '& .ag-cell:focus': {
   border: 'none !important',
   outline: 'none',
  },

  '& .ag-row-selected': {
   backgroundColor: '#8180c3',
   color: 'white',
  },
  '& .ag-theme-alpine .ag-row-selected .ag-row-hover': {
   backgroundColor: 'red !important',
  },
  '& .MuiSvgIcon-root': {
   color: '#663d00',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-row-selected': {
   backgroundColor: '#4abbff',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-ltr .ag-cell-focus': {
   color: '#663d00',
  },
  '& .ag-root-wrapper.ag-layout-normal': {
   height: '100% !important',
  },
 },

 progressSpinner: {
  margin: 'auto',
  position: 'absolute',
  marginLeft: '50%',
  zIndex: 1,
 },
 input: {
  width: '200px',
  marginBottom: '30px',
  marginRight: '5px',
  padding: '7px',
  borderRadius: '5px',
  borderColor: '#D05F33',
  textAlign: 'end',
  color: '#D05F33',
  height: '10px',
  '& .MuiOutlinedInput-notchedOutline': {
   borderColor: '#D05F33 !important',
   color: '#D05F33 !important',
   fontSize: '12px !important',
  },
  '& .MuiOutlinedInput-input': {
   color: '#D05F33 !important',
   fontSize: '12px !important',
   alignItems: 'end',
   textAlign: 'end',
  },
 },
 searchIcon: {
  color: '#D05F33 !important',
 },
 pagination: {
  '& .MuiPaginationItem-root': {
   fontWeight: '600 !important',
   fontSize: '12px !important',
   color: '#FFB614',
  },
 },
});

const DataGridDetails = (props: any) => {
 const [gridApi, setGridApi] = useState<any>(null);
 const [gridColumnms, setGridColumnms] = useState<any>(null);
 const classes = useStyles();
 const dispatch = useDispatch<AppDispatch>();
 const gridRef = useRef<AgGridReact>(null);

 const contractDetails = useSelector(
  (state: RootState) => state.contractDetailData,
  shallowEqual,
 );

 const contractIdData = useSelector(
  (state: RootState) => state.contractId,
  shallowEqual,
 );

 const autoSizeAll = useCallback(() => {
  const allColumnIds: any[] = [];

  if (gridRef?.current?.columnApi) {
   const columns = gridRef?.current?.columnApi.getColumns();

   if (columns) {
    columns.forEach((column: any) => {
     allColumnIds.push(column.colId);
    });
   }
  }

  if (gridRef?.current?.columnApi) {
   gridRef?.current?.columnApi.autoSizeColumns(allColumnIds);
  }
 }, []);

 const defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
  suppressContextMenu: true,
  autoHeaderHeight: true,
 };

 const onGridReady = (params: any) => {
  setGridApi(params.api);
  setGridColumnms(params.columnApi);
  if (params.api) {
   params.api.setHeaderHeight(30);
  }

  if (params.columnApi) {
   const allColumnIds: string[] = [];
   params.columnApi.getColumns().forEach((column: any) => {
    allColumnIds.push(column.getId());
   });
   params.columnApi.autoSizeColumns(allColumnIds);
  }
 };

 const clearAllFilters = () => {
  if (gridApi) {
   gridApi!.setFilterModel(null);
  }
 };

 const onGridSizeChanged = () => {
  if (gridApi) {
   gridApi.sizeColumnsToFit();
  }
 };

 const onRowDataUpdated = () => {
  if (gridApi) {
   gridApi.sizeColumnsToFit();
  }
 };

 const gridOptions: GridOptions = {
  columnDefs: props.columns,
  defaultColDef: {
   width: 150,
   sortable: true,
   resizable: true,
   suppressMenu: false,
  },
  getRowHeight: getRowHeight,
 };

 function getRowHeight(params: RowHeightParams): number | undefined | null {
  return params?.data?.rowHeight;
 }

 const rowClassRules = useMemo<RowClassRules>(() => {
  return {
   'row-gray': function (params) {
    return params.rowIndex % 2 === 0;
   },
   'row-non-gray': function (params) {
    return params.rowIndex % 2 !== 0;
   },
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 const onFirstDataRendered = (params: FirstDataRenderedEvent) => {
  autoSizeAll();
 };

 const onGroupExpandedOrCollapsed = () => {};

 const onColumnVisible = (event: any) => {
  if (!gridColumnms) {
   return;
  }

  const listOfVisibleColumns = gridColumnms.getAllDisplayedColumns();
 };

 return (
  <React.Fragment>
   {props.showProgress ? (
    <div className={classes.progressSpinner}>
     <Box
      sx={{
       width: '35px',
      }}
     >
      <CircularProgress color="secondary" disableShrink />
     </Box>
    </div>
   ) : (
    ''
   )}

   <div
    className="ag-theme-alpine"
    style={{
     width: '95%',
     height: props?.masterProps?.rowHeight
      ? `${props?.masterProps?.rowHeight}px`
      : '250px',
     borderRadius: '5px',
     //margin: '10px',
     marginLeft: '40px',
     marginTop: '10px',
     marginBottom: '10px',
     border: '1px #FFB614 solid',
    }}
   >
    <AgGridReact
     className={classes.agHeader}
     defaultColDef={defaultColDef}
     rowData={contractDetails ? contractDetails : []}
     rowClassRules={rowClassRules}
     columnDefs={props?.masterProps?.detailColumns}
     onGridReady={onGridReady}
     onGridSizeChanged={onGridSizeChanged}
     onNewColumnsLoaded={onRowDataUpdated}
     pagination={!props?.masterProps?.isShowPaging ? true : false}
     localeText={agGridLocale}
     masterDetail={false}
     onFirstDataRendered={onFirstDataRendered}
     suppressRowClickSelection={true}
     onExpandOrCollapseAll={onGroupExpandedOrCollapsed}
     suppressContextMenu={true}
     detailRowAutoHeight={true}
     rowHeight={40}
     rowModelType={'clientSide'}
     onColumnVisible={onColumnVisible}
    ></AgGridReact>

    {contractDetails &&
     contractDetails.length > 0 &&
     contractDetails[0].attachedFiles &&
     contractDetails[0].attachedFiles.length > 0 &&
     contractDetails[0].attachedFiles.map((file) => (
      <div
       style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: '120px',
        overflow: 'auto',
        justifyItems: 'center',
        alignItems: 'flex-start',
        border: '1px solid #ffb614',
        padding: '5px',
        fontSize: '10px',
       }}
      >
       <DownloadButton
        key={file.id}
        url={`/feedback/download/${file.id}`}
        fileName={file.fileName}
        icon={
         <StapletIcon
          style={{
           width: '15px',
           height: '15px',
           marginRight: '10px',
          }}
         />
        }
       >
        {file.fileName}
       </DownloadButton>
      </div>
     ))}
   </div>
  </React.Fragment>
 );
};

export default memo(DataGridDetails);
